import type { ReactNode } from "react";
import type { DataElScope } from "@/utils/dataEl";
import { Cimage } from "../Cimage";
import { Cmembericon, type CmembericonProps } from "../Cmembericon";

const MEMBER_PROVIDER_ALT_FALLBACK = "provider";

export interface CreferenceMemberLeadingProps {
  dataElScope: DataElScope;
  memberColor: string | null;
  memberProviderIconPath: string;
  memberProviderSlug: string;
  memberRole: CmembericonProps["role"] | null;
}

export function CreferenceMemberLeading({
  dataElScope,
  memberColor,
  memberProviderIconPath,
  memberProviderSlug,
  memberRole,
}: CreferenceMemberLeadingProps): ReactNode {
  return (
    <Cmembericon
      dataElScope={dataElScope}
      role={memberRole ?? undefined}
      colorHex={memberColor ?? undefined}
      size={16}
      radius={8}
      content={
        <Cimage
          src={memberProviderIconPath}
          alt={memberProviderSlug || MEMBER_PROVIDER_ALT_FALLBACK}
          static={true}
          objectFit="contain"
          style={{
            width: "70%",
            height: "70%",
          }}
        />
      }
      style={{ margin: "0px" }}
    />
  );
}
